export const MIN_AMOUNT_PADDING = 0;
export const MAX_AMOUNT_PADDING = 100;

export const DEFAULT_LABEL = 'Padding';
